import React from "react";
import "./App.css";
import Router from "./routers/index";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import { CookiesProvider } from "react-cookie";

const alertOptions = {
  // you can also just use 'bottom center'
  position: positions.TOP_RIGHT,
  timeout: 5000,
  offset: "100px",
  // you can also just use 'scale'
  transition: transitions.SCALE,
};

function App() {
  return (
    <CookiesProvider>
      <AlertProvider template={AlertTemplate} {...alertOptions}>
        <Router />
      </AlertProvider>
    </CookiesProvider>
  );
}

export default App;
